import RemoteAccessService from './remote.service';
import PanelService from './panel.service';
import DeviceService from './device.service';
import controlPanelConfigService from './controlPanelConfig.service'


export default angular.module('app.main.panel.services.module', [])
	.service('PanelService', PanelService)
	.service('RemoteAccessService', RemoteAccessService)
	.service('DeviceService', DeviceService)
	.service('ControlPanelConfigService', controlPanelConfigService)
	.name



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/services/index.js
 **/